import type { ReactNode } from 'react';

import { PhoneMenuMark, PhoneNavStatus } from './PhoneNavStatus';
import { ShellFrame } from './ShellFrame';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export interface AppShellProps {
  workspaceId: string;
  children: ReactNode;
}

/**
 * The workspace shell: `ShellFrame` filled with what a workspace has.
 *
 * One of the frame's two callers — the organization console is the other. Everything
 * structural moved into the frame, so this is now only the answer to "what goes in the
 * rail and the bar when the reader is inside a workspace".
 */
export function AppShell({ workspaceId, children }: AppShellProps) {
  return (
    <ShellFrame
      rail={(collapsed) => (
        <Sidebar workspaceId={workspaceId} collapsed={collapsed} />
      )}
      topbar={<Topbar workspaceId={workspaceId} />}
      phoneMenuMark={<PhoneMenuMark workspaceId={workspaceId} />}
      phoneNavHeader={<PhoneNavStatus workspaceId={workspaceId} />}
    >
      {children}
    </ShellFrame>
  );
}
